module.exports = __webpack_public_path__ + "static/award-mi_border-7065ca7801c20a8080524eade3ae2ebc.png";